import React, { memo, useTransition } from "react";
import { CheckCircleIcon, Tooltip, XCircleIcon } from "@";

const TogglePublishStatus = memo(function TogglePublishStatus({ row, click }) {
  const isPublished = row.isPublished;
  const tooltipId = `action-published-${isPublished ? "false" : "true"}-${row.id}`;
  const tooltipTitle = isPublished ? "إلغاء النشر" : "نشر";
  const Icon = isPublished ? XCircleIcon : CheckCircleIcon;
  const [isPending, startTransition] = useTransition();

  return (
    <div>
      <span
        onClick={() => startTransition(() => click(row.id, !isPublished))}
        className={`icon-style group/toggle cursor-pointer ${
          isPublished
            ? "hover:!bg-rose-50 hover:!text-rose-600 dark:hover:!bg-rose-950/40 dark:hover:!text-rose-400"
            : "hover:!bg-emerald-50 hover:!text-emerald-600 dark:hover:!bg-emerald-950/40 dark:hover:!text-emerald-400"
        } ${isPending ? "animate-pulse opacity-60" : ""}`}
        data-tooltip-placement="right"
        data-tooltip-target={tooltipId}
      >
        <Icon className="w-6 transition-transform group-hover/toggle:scale-110" />
      </span>

      <Tooltip
        className="dark:bg-gray-600"
        title={tooltipTitle}
        id={tooltipId}
      />
    </div>
  );
});

export default TogglePublishStatus;
